import React from "react";

// Styles
import "./styles.scss";

const TextArea = ({ placeholder = "", name = "", className, onChange, ...rest }) => {
  return (
    <>
      <textarea
        rows={2}
        // cols={10}
        name={name}
        placeholder={placeholder}
        className={"textBoxStyle"}
        autoComplete={"off"}
        onChange={onChange}
        {...rest}
      ></textarea>
    </>
  );
};

export default TextArea;

// import React, { useRef, useEffect } from "react";
// import "./styles.scss";

// const TextArea = ({ placeholder = "", name = "", className, onChange, ...rest }) => {
//   const textAreaRef = useRef(null);

//   // Function to adjust height dynamically
//   const adjustHeight = () => {
//     const textArea = textAreaRef.current;
//     if (textArea) {
//       textArea.style.height = "auto"; // Reset height
//       textArea.style.height = textArea.scrollHeight + "px"; // Set new height
//     }
//   };

//   useEffect(() => {
//     adjustHeight(); // Adjust height on mount
//   }, []);

//   const handleChange = (event) => {
//     if (onChange) onChange(event);
//     adjustHeight();
//   };

//   return (
//     <textarea
//       ref={textAreaRef}
//       rows={1} // Set initial row to 1
//       name={name}
//       placeholder={placeholder}
//       className={`textBoxStyle ${className || ""}`}
//       autoComplete="off"
//       onChange={handleChange}
//       {...rest}
//     ></textarea>
//   );
// };

// export default TextArea;

